import EventManager from "~/ts/library/EventManager"
import {OperatorStatus} from "~/chat/ts/data/OperatorStatus";

export const SCROLL_TO_USERNAME_IN_BUDDY_LIST = "scrollToUsernameInBuddyList";
export const SCROLL_CHAT_TO_BOTTOM = "scrollChatToBottom";
export const READ_ALL_MESSAGES_OF_CLIENT = "readAllMessagesOfClient";
export const OPERATOR_RELOAD_APP_CONFIG = "operatorReloadAppConfig";
export const MAKE_OPERATOR_LOGOUT = "makeOperatorLogout";
export const OPERATOR_LOGGED_IN = "operatorLoggedIn";
export const BEFORE_OPERATOR_LOGGED_OUT = "beforeOperatorLoggedOut";
export const OPERATOR_LOGGED_OUT = "operatorLoggedOut";
export const NEW_HAVE_NO_ANSWER_CLIENT = "newHaveNoAnswerClient";
export const UPDATE_ORDER = "updateBuddyListOrderByUsername";
export const SET_OPERATOR_STATUS = "setOperatorStatus";
export const CHANGE_NOTIFICATIONS_CONFIG = "changeNotificationsConfig";
export const CHANGE_SPELLCHECK_CONFIG = "changeSpellcheckConfig";

export const ADD_AND_OPEN_CLIENT_BY_USERNAME = "addAndOpenClientByUsername";
export const COPY_SHORTCUT = "copyShortcut";
export const OPERATOR_STATUS_UPDATED = "operatorStatusUpdated";
export const MESSAGE_REMOVED = "messageRemoved";
export const SELECT_OPERATOR_FOR_ANOTHER_OPERATORS_DIALOG = "selectOperatorForAnotherOperatorsDialog";

export const EVENT_OPEN_MESSAGE_SEARCH_TAB = "openMessageSearchTab";

export const EVENT_OPEN_CROSS_OPERATOR_CONVERSATION_TAB = "openCrossOperatorConversationTab";

export function getTranslateMessageEventId(messageId: number) {
    return `translateMessage_${messageId}`;
}

export const OperatorApplicationEventManager = new EventManager();

export interface SetOperatorStatusEventPayload {
    statusId: OperatorStatus;
    customStatusId?: string;
    rememberLastStatus?: boolean;
}

export interface OperatorStatusUpdatedEventPayload {
    operator: OperatorApplicationApi.OperatorGetParamsOperatorOpenApiModel,
    previousVersion: OperatorApplicationApi.OperatorGetParamsOperatorOpenApiModel
}

export interface AddAndOpenClientByUsernamePayloadInterface {
    username: string,
    messageId?: number,
    dialogId?: number
}